import TransferOverheadProduksiAsetApi from "./TransferOverheadProduksiAsetApi";

export default TransferOverheadProduksiAsetApi;
